import { Component } from '@angular/core';

import { AiAgentChatStateService } from '../../../core/services/ai-agent-chat-state';
import { ChatWidgetStateService } from '../../../core/services/chat-widget-state.service';

@Component({
  selector: 'app-ai-chat',
  standalone: false,
  templateUrl: './ai-chat.html',
  styleUrl: './ai-chat.scss',
})
export class AiChat {
  message = '';
  showConversationList = true;

  constructor(
    public readonly state: AiAgentChatStateService,
    private readonly chatState: ChatWidgetStateService,
  ) {}

  toggle(): void {
    if (!this.state.open()) this.chatState.close();
    this.state.toggle();
    if (this.state.open()) this.showConversationList = true;
  }

  openConversation(id: string): void {
    this.showConversationList = false;
    void this.state.selectConversation(id);
  }

  startConversation(): void {
    this.showConversationList = false;
    this.state.newConversation();
  }

  backToConversationList(): void { this.showConversationList = true; }

  async send(submittedContent?: string): Promise<void> {
    const content = (submittedContent ?? this.message).trim();
    if (!content || this.state.sending()) return;
    this.message = '';
    await this.state.send(content);
  }

}
